// extracted by mini-css-extract-plugin
export default {"root":"add-offer-button_root___Km8l"};